import { FunctionComponent } from 'react';
import { ErrorMessage, Field, FieldProps } from 'formik';
import { oneLine } from 'common-tags';

import { TextareaProps } from './types';

export const Textarea: FunctionComponent<TextareaProps> = ({
    className = '',
    name,
    label,
    disabled = false,
    placeholder,
    rows = 2,
    cols = 20,
    maximo = 5000,
    ...props
}: TextareaProps) => (
    <Field name={name}>
        {({ field, meta }: FieldProps) => (
            <div
                className={`flex flex-col gap-2 aria-disabled:opacity-40 ${className}`}
                aria-disabled={disabled}
            >
                {label && (
                    <label
                        htmlFor={name}
                        className={oneLine`
            text-body text-body--m
            ${meta.error && meta.touched
                                ? 'text-tertiary-500'
                                : 'text-text-secondary'
                            }
          `}
                    >
                        {label}
                    </label>
                )}

                <textarea
                    id={name}
                    placeholder={placeholder}
                    disabled={disabled}
                    maxLength={maximo}
                    rows={rows}
                    cols={cols}
                    className={oneLine`
                        border-secondary-600 text-text-primary text-body text-body--l ring-secondary-600
                        ${meta.error && meta.touched
                            ? 'ring-tertiary-500 border-tertiary-500 placeholder:text-tertiary-500'
                            : ''
                        }
                        ${disabled
                            ? ''
                            : 'focus:ring-primary-500 focus:placeholder:text-text-secondary focus:border-primary-500 active:ring-primary-500 active:placeholder:text-text-secondary active:border-primary-500'
                        }
                    `}
                    {...props}
                    {...field}
                />

                <ErrorMessage name="textarea">
                    {(msg) => (
                        <div className="text-tertiary-500 text-body text-body--s">
                            {msg}
                        </div>
                    )}
                </ErrorMessage>
            </div>
        )}
    </Field>
);

Textarea.displayName = 'Textarea';
